<template>
  <div>
    <div
      class="alert alert-custom alert-white alert-shadow fade show gutter-b"
      role="alert"
    >
      <div class="alert-icon">
        <i class="fas fa-info text-primary"></i>
      </div>
      <div class="alert-text">
        Selectionner une <strong>Abonnement</strong> pour voir le detail.
      </div>
    </div>
    <!--begin::Dashboard-->

    <div class="row" ref="stats">
      <div class="col-xl-12">
        <!--begin::Base Table Widget 7-->
        <div class="card card-custom card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 mt-5">
            <h3 class="card-title align-items-start flex-column text-dark">
              <span class="font-weight-bolder text-dark"
                >Liste des abonnement</span
              >
            </h3>
            <div class="card-toolbar"></div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body py-0 mt-n3">
            <!--begin::Table-->
            <DxDataGrid
              @initialized="saveGridInstance"
              :data-source="dataSource"
              :remote-operations="true"
              :columns="columns"
              :show-row-lines="true"
              :word-wrap-enabled="true"
              :show-borders="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :row-alternation-enabled="false"
              :hover-state-enabled="true"
              :column-auto-width="true"
              :show-column-lines="true"
              :selection="{ mode: 'none' }"
              @row-click="onRowClick"
              :date-serialization-format="dateSerializationFormat" 
            >
              >
              <DxExport :enabled="true" file-name ="Demandes" />
              <DxLoadPanel :enabled="true" />
              <DxFilterRow :visible="true" />

              <DxHeaderFilter :visible="true" :allow-search="true" />
              <!-- <DxStateStoring :enabled="true" type="localStorage" storage-key="medicineList" /> -->
              <DxPager
                :show-page-size-selector="true"
                :allowed-page-sizes="[5, 10, 20]"
              />
              <DxGroupPanel :visible="true" />
              <DxGrouping :auto-expand-all="true" />
              <DxPaging :page-size="10" />
              <DxSearchPanel :visible="true" />
              <DxSummary>
                <DxTotalItem
                  column="createdAtUtc"
                  summary-type="count"
                  display-format="{0}"
                />
                <DxTotalItem
                  column="amount"
                  summary-type="sum"
                  :value-format="{ type: 'fixedPoint', precision: 2 }"
                  display-format="{0}"
                />
              </DxSummary>
            </DxDataGrid>
            <br />
            <!--end::Table-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Base Table Widget 7-->
      </div>
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import {
  DxDataGrid,
  //DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxPaging,
  //DxStateStoring,
  DxPager,
  DxHeaderFilter,
  DxFilterRow,
  DxSummary,
  DxTotalItem,
  DxLoadPanel,
  DxExport,
} from "devextreme-vue/data-grid";

import { createStore } from "devextreme-aspnet-data-nojquery";
import ApiService from "../../../core/services/api.service";
import DxHelper from "../../../helpers/dx.helper";

export default {
  name: "request-waiting",
  components: {
    DxDataGrid,
    //DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxSearchPanel,
    DxPaging,
    //DxStateStoring,
    DxPager,
    DxHeaderFilter,
    DxFilterRow,
    DxSummary,
    DxTotalItem,
    DxLoadPanel,
    DxExport,
  },
  data() {
    return {
      dateSerializationFormat : "yyyy-MM-ddTHH:mm:ssZ",
      dataSource: {},
      columns: [
        {
          dataField: "createdAtUtc",
          caption: "Date de commande",
          dataType: "datetime",
          sortOrder: "desc",
          // calculateCellValue: (rowData) => {
          //   return FctsHelper.convertUTCDateToLocalDate(rowData.dateUtc);
          // },
        },
        { dataField: "reference", caption: "Réference", dataType: "string" },
        { dataField: "service.name", caption: "Service", dataType: "string" },
        { dataField: "subService.name", caption: "Pack", dataType: "string" }, 
        {
          dataField: "subscriptionType.label",
          caption: "Type",
        },      
        {
          dataField: "requestedBy.userName",
          caption: "Client",
          dataType: "string",
        },
        {
          dataField: "subscriptionState.label",
          caption: "Etat",
        },
      
        {
          dataField: "endDateUtc",
          caption: "Fin d'abonnement",
          dataType: "datetime",
          // calculateCellValue: (rowData) => {
          //   return FctsHelper.convertUTCDateToLocalDate(rowData.dateUtc);
          // },
        },  
        {
          dataField: "amount",
          caption: "Montant",
          format: {
            type: "fixedPoint",
            precision: 2,
          },
        },
        // { dataField: "stateLabel", caption: "Etat" },
      ],
      requestCount: {},
    };
  },
  created() {
    this.$availabilityHub.$on("request-notify", this.refresh);
  },
  beforeDestroy() {
    this.$availabilityHub.$off("request-notify", this.refresh);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Abonnements", route: "list" },
      { title: "Liste" },
    ]);

    this.dataSource = createStore({
      key: "guid",
      loadUrl: `${ApiService.baseURL}admin/v1/subscriptions`,
      onBeforeSend: DxHelper.onBeforeSend,
      onAjaxError: DxHelper.onAjaxError,
    });
  },
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    onRowClick(e) {
      if (e.rowType === "data") {
        this.$router.push({
          name: "requests-detail",
          params: { guid: e.data.guid },
        });
      }
    },
    refresh() {
      this.dataGridInstance.refresh();
    },
  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
